import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import images from './images';

registerImages('cashback', images);

declare global {
  interface RegisteredImages {
    cashback: Record<keyof typeof images, ImageSource>;
  }
}
